import React from 'react';

import RestaurantOrderingHours from './RestaurantOrderingHours';

const RestaurantMenuPageHours = props => {
  const { restaurant, hours, options = {} } = props;
  const { className = '', iconClassName, showAllHours = false } = options;
  if (hours.isClosed) {
    return <div className={`text-danger ${className}`}>Dzisiaj restauracja nie przyjmuje zamówień</div>;
  }
  return <div className={className}>
    <RestaurantOrderingHours
      todayHours={hours}
      restaurant={restaurant}
      iconWrapperClass={iconClassName}
      showAllHours={showAllHours} />
  </div>;
};

export default RestaurantMenuPageHours;
